export default "__VITE_ASSET__BqTcF2va__"